import { Controller } from '@hotwired/stimulus';

// 退職手続きの開始フォーム (#1932)
// - 退職日セレクトに応じて曜日チップを表示
// - 退職理由を選択するまで送信ボタンを無効化
// - warnFor で指定された理由を選んだときだけ警告を表示 (#1946)
export default class extends Controller {
  static targets = ['dateSelect', 'dowChip', 'reason', 'warnBox', 'submit', 'hint'];

  static values = { warnFor: Array };

  static DOW_LABELS = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];

  connect() {
    this.updateDow();
    this.reasonChanged();
  }

  updateDow() {
    if (this.dateSelectTargets.length < 3 || !this.hasDowChipTarget) return;

    const values = {};
    this.dateSelectTargets.forEach((select) => {
      // Rails date_select の name は retire[retired_on(1i)] (1i=年, 2i=月, 3i=日)
      const match = select.name.match(/\((\d)i\)/);
      if (match) values[match[1]] = parseInt(select.value, 10);
    });
    if (!values[1] || !values[2] || !values[3]) {
      this.dowChipTarget.textContent = '';
      return;
    }

    const date = new Date(values[1], values[2] - 1, values[3]);
    this.dowChipTarget.textContent = this.constructor.DOW_LABELS[date.getDay()];
  }

  reasonChanged() {
    const checked = this.reasonTargets.find((radio) => radio.checked);

    if (this.hasSubmitTarget) this.submitTarget.disabled = !checked;
    if (this.hasHintTarget) this.hintTarget.style.display = checked ? 'none' : '';
    if (this.hasWarnBoxTarget) {
      const warn = checked && this.warnForValue.includes(checked.value);
      this.warnBoxTarget.classList.toggle('show', !!warn);
    }
  }
}
